import React from 'react';
import { Link } from 'react-router-dom';
import MenuBar from '../components/Menubar';

type Props = {
  user: any;
};

const CashRewardClosedPage: React.FC<Props> = (props) => {
  return (
    <main className="main-bg cash-reward-closed-page">
      <div className="container">
        <MenuBar user={props.user} />
        <section className="cash-reward-closed-section">
          <div className="cash-reward-closed-overlay">
            <div className="cash-reward-closed-modal" role="dialog" aria-labelledby="cash-reward-closed-title">
              <h1 id="cash-reward-closed-title">Cash Rewards are currently closed</h1>
              <p>
                The Yolomeal Cash Rewards program for Twin Cities is paused while we prepare what comes next.
                Thanks for helping us grow the community and surface the best menu discoveries.
              </p>
              <p>
                We plan to bring rewards back soon. In the meantime, you can keep sharing and upvoting your favorite
                meals on Yolomeal.
              </p>
              <Link className="cash-reward-closed-button" to="/home">
                Back to Home
              </Link>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default CashRewardClosedPage;
